export const defaultLineChartOptions = {
    legend: {
        position: 'none'
    },
    // animation: {
    //     'startup': true,
    //     duration: 1000,
    //     easing: 'out',
    // },
    backgroundColor: {
        fill: '#fff',
        fillOpacity: 1
    },
    chartArea: {
        top: 10,
        left: 50,
        right: 50,
        height: '80%',
        width: '100%'
    },
    width: '100%',
    height: 200,
    hAxis: {
        viewWindowMode: 'maximized',
        gridlines: {
            color: '#e5e5e5',
            count: 7
        }
    },
    vAxis: {
        viewWindowMode: 'explicit',
        viewWindow: {max: 120},

        format: '## %',
        scaleType: 'linear',
        title: 'Poziom sensora w %',
        minValue: -20
    },
    curveType: 'function',
    pointSize: 0,
    tooltip: false,
    series: {
        0: {
            tooltip: false,
            lineWidth: 3,
            color: 'black'
        },
        1: {
            lineWidth: 1,
            lineDashStyle: [10, 5],
            pointSize: 0,
            tooltip: false,
            color: '#fdcc00'
        },
        2: {
            lineWidth: 1,
            lineDashStyle: [10, 5],
            pointSize: 0,
            tooltip: false,
            color: 'rgb(255, 0, 0)'
        }
    }

};
